<template>
  <div class="scale-question-container">
    <div class="scale-wrapper" v-for="(scale, index) in scales" :key="`scale-${index}`">
      <div class="scale-title">{{ $t(scale.title) }}</div>
      <div class="scale-label">{{ $t(scale.description) }}</div>
      <vv-scale
        :from="scale.from || 0"
        :to="scale.to || 5"
        :value="value ? value[index] : null"
        @change="value => handleChange(index, value)"
      />
    </div>
  </div>
</template>

<script>
import { VvScale } from '@/components/common'

export default {
  name: 'Scale',
  components: { VvScale },
  props: {
    question: String,
    scaleType: String,
    expectedResponse: Object,
    value: Array
  },
  data() {
    return {
      scalesByType: {
        scaleTaninsCorpsAlcool: [
          {
            title: 'tasting.scale.tanins.title',
            description: 'tasting.scale.tanins.description'
          },
          {
            title: 'tasting.scale.corps.title',
            description: 'tasting.scale.corps.description'
          },
          {
            title: 'tasting.scale.alcool.title',
            description: 'tasting.scale.alcool.description'
          }
        ],
        scaleAciditeAromesSucrosite: [
          {
            title: 'tasting.scale.acidite.title',
            description: 'tasting.scale.acidite.description'
          },
          {
            title: 'tasting.scale.aromes.title',
            description: 'tasting.scale.aromes.description'
          },
          {
            title: 'tasting.scale.sucrosite.title',
            description: 'tasting.scale.sucrosite.description'
          }
        ]
      }
    }
  },
  computed: {
    scales() {
      return this.scalesByType[this.scaleType]
    }
  },
  methods: {
    handleChange(index, scaleValue) {
      const value = this.value && Array.isArray(this.value) ? [...this.value] : new Array(this.scales.length)

      value[index] = scaleValue
      this.value = value
      const status = this.isCorrect(value)
      console.log('correct', status, this.expectedResponse)
      this.$emit('change', { value, status })
    },
    isCorrect(userChoices) {
      const goodResponses = this.expectedResponse.choices

      for (let i = 0; i < userChoices.length; i++) {
          if (userChoices[i] != goodResponses[i].value) return false
      }
      return true
    }
  }
}
</script>

<style lang="scss" scoped>
.scale-question-container {
  text-align: left;
  padding: 0 15px;
  color: black;

  .scale-wrapper {
    margin-bottom: 15px;
  }

  .scale-title {
    font-weight: bold;
  }

  .scale-label {
    margin-bottom: 4px;
    font-size: 14px;
  }
}
</style>
